import { useEffect, useMemo, useState } from "react";
import "./index.scss";
import {
  message,
  Button,
  Select,
  Tooltip,
  Input,
  InputNumber,
  DatePicker,
  Typography,
  TreeSelect,
  Switch,
  Spin,
} from "antd";
import { licenseColumns, historyColumns } from "../../../LicenseColumnsConfig";
import { useGetState } from "ahooks";
import apis from "../../../apis";
import dayjs from "dayjs";
import moment from "moment/moment";
import { useDispatch } from "react-redux";
import { setBreadcrumbList } from "../../../store/menuInfo/menuInfo";
import debounce from "lodash/debounce";
import { MinusOutlined, PlusOutlined } from "@ant-design/icons";
const { Paragraph, Text } = Typography;

const EditHtml = (props) => {
  const {
    type,
    selectItem = {},
    setEditShow,
    getDataFunc,
    mode, // 'personal' | 'enterprise'
  } = props;

  const personalEnterprise = mode === "personal";

  const [info, setInfo, getInfo] = useGetState([]);
  const [licenseItemsList, setLicenseItemsList] = useState([]);

  const [companys, setCompanys] = useState([]);
  const [companyId, setCompanyId] = useState(null);
  const [companyName, setCompanyName] = useState(null);
  const [userId, setUserId] = useState(null);
  const [userList, setUserList] = useState([]);

  const [versionTypeList, setVersionTypeList, getVersionTypeList] = useGetState(
    [],
  );
  const [versionType, setVersionType, getVersionType] = useGetState(null);

  const [productList, setProductList] = useState([]);
  const [productId, setProductId, getProductId] = useGetState(null);
  const [productPrdId, setProductPrdId] = useState(null);

  const [planId, setPlanId, getPlanId] = useGetState(null);
  const [planList, setPlanList, getPlanList] = useGetState([]);

  const [historyEnterprise, setHistoryEnterprise] = useState([]);
  const [detailInfo, setDetailInfo, getDetailInfo] = useGetState({});

  const [startDate, setStartDate, getStartDate] = useGetState(null);
  const [minDate, setMinDate, getMinDate] = useGetState(null);
  const [checkStatus, setCheckStatus, getCheckStatus] = useGetState(false);
  const dispatch = useDispatch();
  const [searchLoading, setSearchLoading] = useState(false);

  // TOC Specific: Subscription Duration
  const [subsDurType, setSubsDurType] = useState("MONTH");
  const [subsDurNum, setSubsDurNum] = useState(1);
  const [subAcctNum, setSubAcctNum] = useState(
    !personalEnterprise && type === "新增" ? 10 : 0,
  );
  const [isAutoRenew, setIsAutoRenew] = useState(false);
  const [detailLoading, setDetailLoading] = useState(false);
  const [submitLoading, setSubmitLoading] = useState(false);

  // Update Auth Deadline when Duration changes
  useEffect(() => {
    if (type === "新增" || type === "续订") {
      const list = getInfo();
      const newList = list.map((item) => {
        if (item.dic_item_name === "授权截止日期") {
          let interval = "M";
          let time = new Date();
          if (subsDurType === "YEAR") {
            interval = "y";
          }
          if(type === "续订") {
            time = getDetailInfo()?.subs_deadline_time || new Date();
          }
          const newDate = dayjs(time)
            .add(subsDurNum || 0, interval)
            .format("YYYY-MM-DD");

          return { ...item, item_auth_value: newDate };
        }
        return item;
      });
      if (JSON.stringify(list) !== JSON.stringify(newList)) {
        setInfo(newList);
      }
    }
  }, [subsDurType, subsDurNum]);

  //初始化许可项
  const initLicenseItems = (data, defaultInfo) => {
    console.log(defaultInfo, data, getPlanList());
    // If defaultInfo is missing or empty, try to use the plan's default configuration
    // This is useful for "View"/ "Renew" where latest.co_subs_plan_item might be empty
    if (!defaultInfo || defaultInfo.length === 0) {
      // Try to find the plan item to get its default items
      const planItem = getPlanList()?.find(
        (_) =>
          _?.ver_info?.subs_plan_id === getPlanId() ||
          _?.subs_plan_info?.subs_plan_id === getPlanId(),
      );
      if (planItem && planItem.subs_plan_item) {
        defaultInfo = planItem.subs_plan_item;
      }
    }

    let list = [];
    if (defaultInfo) {
      defaultInfo?.forEach((item) => {
        const dicItem = data?.find(
          (_) => _.dic_item_code === item.subs_plan_item_type_code,
        );
        let time = null;
        let _subsDurNum = subsDurNum;
        if (dicItem) {
          if (dicItem.dic_item_name === "授权截止日期") {
            if (type === "续订") {
              item.edit = true;
              time = getDetailInfo()?.subs_deadline_time;
            }
            if (type === "新增") {
              item.edit = true;
            }
            if (type === "升级") {
              item.dateType = true;
              time = getDetailInfo()?.subs_deadline_time;
            }
            if (type === "查看") {
              time = getDetailInfo()?.subs_deadline_time;
              _subsDurNum = 0;
            }
            let interval = "M";
            if (subsDurType === "YEAR") {
              interval = "y";
            }
            item.item_auth_value = dayjs(time || new Date())
              .add(_subsDurNum || 0, interval)
              .format("YYYY-MM-DD");
          }
          item = { ...item, ...dicItem, seq: item.seq };
          list.push(item);
        }
      });
    }
    setInfo(list);
  };

  //获取许可项列表
  const getLicenseItemsList = (co_id, defaultInfo) => {
    apis.getLicenseItemsList(co_id).then((res) => {
      console.log("🚀 ~ 许可项列表:", res);
      if (res.code === 200) {
        setLicenseItemsList(res.data);
        initLicenseItems(res.data, defaultInfo);
      }
    });
  };

  // Search User by Phone
  const searchUser = (phone) => {
    if (!phone) {
      setUserList([]);
      return;
    }
    setSearchLoading(true);
    apis.searchUserByPhone({ phone }).then((res) => {
      setSearchLoading(false);
      if (res.code === 200) {
        setUserList(res.data || []);
      }
    });
  };

  // Get User Companies
  const fetchUserCompanies = (uid, prd_id) => {
    if (!uid || !prd_id) {
      setCompanys([]);
      setCompanyId(null);
      setCompanyName(null);
      return;
    }
    apis.getUserCompanies({ user_id: uid, prd_id }).then((res) => {
      if (res.code === 200) {
        const list = res.data || [];
        setCompanys(list);
        if (list.length > 0) {
          setCompanyId(list[0].toc_co_id);
          setCompanyName(list[0].toc_co_name);
        } else {
          setCompanyId(null);
          setCompanyName(null);
        }
      }
    });
  };

  const debounceUserFetcher = useMemo(() => {
    return debounce(searchUser, 500);
  }, []);

  //获取版本类型
  const getVersionTypeListFunc = () => {
    apis
      .getVerType(personalEnterprise ? "PERSONAL" : "ENTERPRISE")
      .then((res) => {
        if (res.code === 200) {
          const list =
            Object.keys(res.data || {})?.map((key) => {
              let item = {
                value: (res.data[key] || {})?.dic_item_code,
                label: (res.data[key] || {})?.dic_item_name,
              };
              return item;
            }) || [];
          setVersionTypeList(list);
        }
      });
  };

  //获取产品列表
  const getProductList = () => {
    apis.getProductList("TOC").then((res) => {
      console.log("🚀 ~ 产品列表:", res);
      if (res.code === 200) {
        setProductList(res.data);
      }
    });
  };

  //获取订阅方案
  const getPlanListFunc = () => {
    let typeCode = getVersionType();
    const params = {
      product_name: getProductId(),
      version_type_code: typeCode,
      subs_plan_status_code: "VALID",
      page: 1,
      page_size: 9999,
    };
    apis.getTocSubscriptionPlanList(params).then((res) => {
      console.log("🚀 ~ 订阅方案:", res);
      if (res.code === 200) {
        setPlanList(res.data?.result || []);
        if (type === "续订") {
          if ((res.data?.result || [])?.length === 0) {
            return;
          }
          console.log(getPlanId());
          const item = (res.data?.result || [])?.find(
            (_) => _?.ver_info?.subs_plan_id === getPlanId(),
          );
          if (item) {
            getLicenseItemsList(
              (item?.subs_plan_info || {})?.prd_co_id,
              item?.subs_plan_item || [],
            );
          }
        }
      } else {
        message.error(res.message);
      }
    });
  };

  // TOC History Columns
  const tocHistoryColumns = [
    {
      name: "订阅方案编码",
      require: false,
      key: "subs_plan_code",
      flex: 1,
      render: (item) => item.subs_plan_code,
    },
    {
      name: "订阅方案名称",
      require: false,
      key: "subs_plan_name",
      flex: 1,
      render: (item) => item.subs_plan_name,
    },
    {
      name: "版本",
      require: false,
      key: "ver_no",
      width: "80px",
      render: (item) => item.ver_no,
    },
    {
      name: "订阅/续订时间",
      require: false,
      key: "subs_renew_time",
      width: "160px",
      render: (item) => item.subs_renew_time,
    },
    {
      name: "订阅类型",
      require: false,
      key: "subs_type_name",
      width: "120px",
      render: (item) => item.subs_type_name || item.subs_type_code,
    },
    {
      name: "订阅时长",
      require: false,
      key: "subs_duration",
      width: "120px",
      render: (item) => item.subs_duration,
    },
    {
      name: "订阅开始时间",
      require: false,
      key: "subs_start_date",
      width: "120px",
      render: (item) => item.subs_start_date,
    },
    {
      name: "订阅到期时间",
      require: false,
      key: "subs_deadline_date",
      width: "120px",
      render: (item) => item.subs_deadline_date,
    },
    {
      name: "备注",
      require: false,
      key: "remark",
      flex: 2,
      render: (item) => <span style={{ color: "red" }}>{item.remark}</span>,
    },
  ];

  //获取订阅详情
  const getSubscriptionDetail = () => {
    const apiFunc = personalEnterprise
      ? apis.getTocPersonalSubscriptionDetail
      : apis.getTocEnterpriseSubscriptionDetail;

    if (!selectItem?.toc_subs_id) return;

    setDetailLoading(true);
    apiFunc({
      toc_subs_id: selectItem?.toc_subs_id,
    })
      .then((res) => {
        console.log("Subscription Detail:", res);
        if (res.code === 200) {
          const latest = res.data?.latest || {};
          setDetailInfo(latest);
          if (!personalEnterprise) {
            setSubAcctNum(latest?.sub_acct_num || 0);
          }
          setHistoryEnterprise(res.data?.history || []);

          // 无论是查看还是续订，都先获取一下版本类型列表，方便反显名称
          getVersionTypeListFunc();

          // 尝试获取 Plan 详情以拿到 prd_co_id
          // 只有拿到 prd_co_id 才能获取许可项定义的 columns
          const fetchPlanAndLicense = () => {
            const params = {
              product_name: latest?.product_name,
              version_type_code: latest?.version_type_code,
              subs_plan_status_code: latest?.subs_plan_status_code || "VALID",
              page: 1,
              page_size: 9999,
            };
            apis
              .getTocSubscriptionPlanList(params)
              .then((planRes) => {
                if (planRes.code === 200) {
                  const planItem = (planRes.data?.result || []).find(
                    (p) =>
                      p?.ver_info?.subs_plan_id ===
                        (latest?.subs_plan_id || latest?.subs_plan_code) ||
                      p?.ver_info?.subs_plan_id ===
                        latest?.subs_plan?.subs_plan_id,
                  );

                  if (planItem) {
                    // Found the plan, get prd_co_id
                    const prd_co_id = planItem?.subs_plan_info?.prd_co_id;
                    if (prd_co_id) {
                      // Use plan items if subscription items are empty
                      const defaultItems =
                        latest?.co_subs_plan_item &&
                        latest?.co_subs_plan_item.length > 0
                          ? latest?.co_subs_plan_item
                          : planItem?.subs_plan_item || [];

                      getLicenseItemsList(prd_co_id, defaultItems);
                      setDetailLoading(false);
                      return;
                    }
                  } else {
                    // 如果列表里找不到(可能下架了), 尝试直接用 latest 里的 info (如果后端给了)
                    // 或者无法展示许可项
                    if (latest?.prd_co_id || latest?.subs_plan?.prd_co_id) {
                      getLicenseItemsList(
                        latest?.prd_co_id || latest?.subs_plan?.prd_co_id,
                        latest?.co_subs_plan_item || [],
                      );
                    }
                  }
                }
                setDetailLoading(false);
              })
              .catch(() => setDetailLoading(false));
          };

          fetchPlanAndLicense();

          if (type === "续订") {
            const uid = latest?.toc_user_id || latest?.user_id;
            setUserId(uid);
            if (uid) {
              setUserList([
                {
                  user_id: uid,
                  user_name: latest?.user_name || latest?.user_nickname,
                  nick_name: latest?.user_nickname,
                  phone: latest?.user_phone,
                },
              ]);
            }

            const cid = latest?.toc_co_id || latest?.co_id;
            if (cid) {
              setCompanyId(cid);
              setCompanys([
                {
                  toc_co_id: cid,
                  toc_co_name: latest?.co_name || latest?.toc_co_name,
                },
              ]);
              setCompanyName(latest?.co_name || latest?.toc_co_name);
            } else {
              setCompanyId(null);
              setCompanyName(null);
              setCompanys([]);
            }

            setVersionType(
              latest?.version_type_code ||
                latest?.subs_plan_code?.split("_")[0],
            );
            setProductId(latest?.product_name);
            setPlanId(latest?.subs_plan_id || latest?.subs_plan_code);
            if (!personalEnterprise) {
              setSubAcctNum(latest?.sub_acct_num || 0);
            }

            setTimeout(() => {
              getPlanListFunc();
            }, 100);
          }
        } else {
          setDetailLoading(false);
        }
      })
      .catch(() => setDetailLoading(false));
  };

  useEffect(() => {
    if (type === "新增") {
      getVersionTypeListFunc();
      getProductList();
      setInfo([]);
      setUserId(null);
      setCompanyId(null);
      setCompanys([]);
      setProductId(null);
      setProductPrdId(null);
    }
    if (type === "查看" || type === "续订") {
      getSubscriptionDetail();
    }
    dispatch(
      setBreadcrumbList([
        {
          title: (
            <span
              className="backSpan"
              onClick={() => {
                setEditShow(false);
              }}
            >
              {personalEnterprise ? "个人订阅管理" : "企业订阅管理"}
            </span>
          ),
        },
        {
          title: type === "新增" ? "订阅" : type === "查看" ? "查看订阅" : type,
        },
      ]),
    );
  }, [type]);

  const initItem = (item, column, index) => {
    // let typeCode = getVersionType();
    // if (
    //   (item.edit ||
    //     typeCode === "ENTERPRISE_CTO_EDITION" ||
    //     typeCode === "PERSONAL_CTO_EDITION") &&
    //   column.key === "item_auth_value"
    // ) {
    //   if (item.dateType) {
    //     return (
    //       <div>
    //         <Paragraph
    //           style={{ marginBottom: "0px" }}
    //           ellipsis={{
    //             rows: 2,
    //             tooltip: {
    //               title: item[column.key] || "-",
    //             },
    //           }}
    //         >
    //           <div
    //             style={{
    //               textAlign: "left",
    //               whiteSpace: "pre-wrap",
    //             }}
    //           >
    //             {item[column.key] ?? "-"}
    //           </div>
    //         </Paragraph>
    //       </div>
    //     );
    //   } else if (item.edit) {
    //     const disabledDate = (current) => {
    //       let time = getMinDate() || new Date();
    //       if (new Date(time)?.getTime() < new Date()?.getTime()) {
    //         time = new Date();
    //       }
    //       return current && current < dayjs(time).endOf("day");
    //     };
    //     return (
    //       <DatePicker
    //         style={{ width: "100%" }}
    //         format="YYYY-MM-DD"
    //         disabledDate={disabledDate}
    //         value={item[column.key] ? dayjs(item[column.key]) : null}
    //         onChange={(value, dateString) => {
    //           setInfo((prev) => {
    //             prev = prev.map((_, _index) => {
    //               if (index === _index) {
    //                 _[column.key] = dateString;
    //               }
    //               return _;
    //             });
    //             return [...prev];
    //           });
    //         }}
    //         status={
    //           column.require && getCheckStatus() && !item[column.key]
    //             ? "error"
    //             : ""
    //         }
    //       />
    //     );
    //   } else if (item.type === "select") {
    //     return (
    //       <Select
    //         style={{ width: "100%" }}
    //         disabled={item.require}
    //         showSearch
    //         filterOption={(input, option) =>
    //           (option?.label ?? "").toLowerCase().includes(input.toLowerCase())
    //         }
    //         status={
    //           column.require && getCheckStatus() && !item[column.key]
    //             ? "error"
    //             : ""
    //         }
    //         onChange={(value) => {
    //           setInfo((prev) => {
    //             const licenseItem =
    //               licenseItemsList?.find((__) => __.dic_item_code === value) ||
    //               {};
    //             prev = prev.map((_, _index) => {
    //               if (index === _index) {
    //                 _[column.key] = value;
    //                 _ = { ...(_ || {}), ...licenseItem };
    //               }
    //               return _;
    //             });
    //             return [...prev];
    //           });
    //         }}
    //         value={item[column.key]}
    //         options={(item?.select_content || [])?.map((_) => ({
    //           value: _,
    //           label: _,
    //         }))}
    //         placeholder={`请选择${column?.name}`}
    //       ></Select>
    //     );
    //   } else if (item.type === "more_select") {
    //     const initTreeData = (list, name_key, code_key) => {
    //       return list?.map((_) => {
    //         const __ = {
    //           title: _[name_key],
    //           value: _[code_key],
    //           key: _[code_key],
    //         };
    //         if (_.children) {
    //           __.children = initTreeData(_.children, name_key, code_key);
    //         }
    //         return __;
    //       });
    //     };

    //     const tagRender = (props) => {
    //       return <div className="moreSelectTag">{props?.label}</div>;
    //     };
    //     const maxTagPlaceholder = (list) => {
    //       return <div className="moreSelectOmittedTag">{list?.length}</div>;
    //     };
    //     const rProps = {
    //         treeData: initTreeData(
    //           (item.fun_tree || {})?.children || [],
    //           "func_name",
    //           "func_code"
    //         ),
    //         dropdownStyle: {
    //           maxHeight: 400,
    //           overflow: "auto",
    //           minWidth: 200,
    //         },
    //         className:
    //           ((item[column.key] || {})[item.fun_key] || [])?.length > 0
    //             ? "hasFunValue"
    //             : null,
    //         treeDefaultExpandAll: true,
    //         maxTagCount: "responsive",
    //         placeholder: `请选择授权的${item.fun_key}`,
    //         treeCheckable: true,
    //         maxTagPlaceholder,
    //         // showCheckedStrategy: SHOW_PARENT,
    //         onChange: (value) => {
    //           setInfo((prev) => {
    //             prev = prev.map((_, _index) => {
    //               if (index === _index) {
    //                 if (!_[column.key]) {
    //                   _[column.key] = {};
    //                 }
    //                 _[column.key][item.fun_key] = value;
    //               }
    //               return _;
    //             });
    //             return [...prev];
    //           });
    //         },
    //         tagRender,
    //         value: (item[column.key] || {})[item.fun_key],
    //         // status:
    //         //   column.require &&
    //         //   getCheckStatus() &&
    //         //   ((item[column.key] || {})[item.fun_key] || [])?.length === 0
    //         //     ? "error"
    //         //     : "",
    //       },
    //       lProps = {
    //         treeData: initTreeData(
    //           (item.menu_tree || {})?.children || [],
    //           "menu_name",
    //           "menu_code"
    //         ),
    //         className:
    //           ((item[column.key] || {})[item.menu_key] || [])?.length > 0
    //             ? "hasMenuValue"
    //             : null,
    //         treeDefaultExpandAll: true,
    //         maxTagCount: "responsive",
    //         dropdownStyle: {
    //           maxHeight: 400,
    //           overflow: "auto",
    //           minWidth: 200,
    //         },
    //         tagRender,
    //         maxTagPlaceholder,
    //         placeholder: `请选择授权的${item.menu_key}`,
    //         treeCheckable: true,
    //         // showCheckedStrategy: SHOW_PARENT,
    //         onChange: (value) => {
    //           setInfo((prev) => {
    //             prev = prev.map((_, _index) => {
    //               if (index === _index) {
    //                 if (!_[column.key]) {
    //                   _[column.key] = {};
    //                 }
    //                 _[column.key][item.menu_key] = value;
    //               }
    //               return _;
    //             });
    //             return [...prev];
    //           });
    //         },
    //         value: (item[column.key] || {})[item.menu_key],
    //         // status:
    //         //   column.require &&
    //         //   getCheckStatus() &&
    //         //   ((item[column.key] || {})[item.menu_key] || [])?.length === 0
    //         //     ? "error"
    //         //     : "",
    //       };

    //     return (
    //       <div
    //         style={{
    //           display: "flex",
    //           alignItems: "center",
    //           justifyContent: "space-between",
    //           width: "100%",
    //           height: "100%",
    //         }}
    //       >
    //         <TreeSelect
    //           {...lProps}
    //           style={{ width: "calc(50% - 5px)", "--text": "111" }}
    //         />
    //         <TreeSelect {...rProps} style={{ width: "calc(50% - 5px)" }} />
    //       </div>
    //     );
    //   } else {
    //     return (
    //       <Input
    //         value={item[column.key]}
    //         placeholder={`请输入${column?.name}`}
    //         style={{ width: "100%" }}
    //         status={
    //           column.require &&
    //           getCheckStatus() &&
    //           (item[column.key] === null ||
    //             item[column.key] === undefined ||
    //             item[column.key] === "")
    //             ? "error"
    //             : ""
    //         }
    //         // max={99999}
    //         onBlur={() => {
    //           if (item[column.key] === "-") {
    //             setInfo((prev) => {
    //               prev = prev.map((_, _index) => {
    //                 if (index === _index) {
    //                   _[column.key] = "";
    //                 }
    //                 return _;
    //               });
    //               return [...prev];
    //             });
    //           }
    //         }}
    //         onChange={(e) => {
    //           let value = e.target.value?.replace(/[^\-?\d]/g, "")?.slice(0, 5);
    //           if (value === "-") {
    //             value = "-";
    //           } else if (value <= -1) {
    //             value = "-1";
    //           } else {
    //             value = value ? parseInt(value)?.toString() : "";
    //             if (value === "NaN") {
    //               value = "0";
    //             }
    //           }
    //           setInfo((prev) => {
    //             prev = prev.map((_, _index) => {
    //               if (index === _index) {
    //                 _[column.key] = value;
    //               }
    //               return _;
    //             });
    //             return [...prev];
    //           });
    //         }}
    //       ></Input>
    //     );
    //   }
    // }
    // if (
    //   (item.edit ||
    //     typeCode === "ENTERPRISE_CTO_EDITION" ||
    //     typeCode === "PERSONAL_CTO_EDITION") &&
    //   column.key === "item_alert_value"
    // ) {
    //   if (item.dateType) {
    //     return (
    //       <div>
    //         <Paragraph
    //           style={{ marginBottom: "0px" }}
    //           ellipsis={{
    //             rows: 2,
    //             tooltip: {
    //               title: item[column.key] || "-",
    //             },
    //           }}
    //         >
    //           <div
    //             style={{
    //               textAlign: "left",
    //               whiteSpace: "pre-wrap",
    //             }}
    //           >
    //             {item[column.key] ?? "-"}
    //           </div>
    //         </Paragraph>
    //       </div>
    //     );
    //   }
    //   let disabled = false;
    //   let placeholder = `请输入${column?.name}`;
    //   if (item.alert_value) {
    //     disabled = true;
    //     placeholder = "不涉及";
    //   }
    //   return (
    //     <Input
    //       disabled={disabled}
    //       value={item[column.key]}
    //       placeholder={placeholder}
    //       style={{ width: "100%" }}
    //       // max={99999}
    //       status={
    //         column.require &&
    //         getCheckStatus() &&
    //         (item[column.key] === null ||
    //           item[column.key] === undefined ||
    //           item[column.key] === "")
    //           ? "error"
    //           : ""
    //       }
    //       onBlur={() => {
    //         if (item[column.key] === "-") {
    //           setInfo((prev) => {
    //             prev = prev.map((_, _index) => {
    //               if (index === _index) {
    //                 _[column.key] = "";
    //               }
    //               return _;
    //             });
    //             return [...prev];
    //           });
    //         }
    //       }}
    //       onChange={(e) => {
    //         let value = e.target.value?.replace(/[^\-?\d]/g, "")?.slice(0, 5);
    //         if (value === "-") {
    //           value = "-";
    //         } else if (value <= -1) {
    //           value = "-1";
    //         } else {
    //           value = value ? parseInt(value)?.toString() : "";
    //           if (value === "NaN") {
    //             value = "0";
    //           }
    //         }
    //         setInfo((prev) => {
    //           prev = prev.map((_, _index) => {
    //             if (index === _index) {
    //               _[column.key] = value;
    //             }
    //             return _;
    //           });
    //           return [...prev];
    //         });
    //       }}
    //     ></Input>
    //   );
    // }
    //授权值 且为多选框时
    if (item.type === "more_select" && column.key === "item_auth_value") {
      //code和对应的中文拿出来
      const codeObj = {};
      let count = 1;
      const flatTree = (list, codeKey, nameKey) => {
        list?.forEach((_) => {
          if (_?.children) {
            flatTree(_?.children, codeKey, nameKey);
          }
          codeObj[_[codeKey]] = { name: _[nameKey], index: count };
          count = count + 1;
        });
      };
      flatTree(item.fun_tree?.children || [], "func_code", "func_name");
      flatTree(item.menu_tree?.children || [], "menu_code", "menu_name");
      const funList = ((item?.item_auth_value || {})[item.fun_key] || [])?.sort(
        (a, b) => codeObj[a]?.index - codeObj[b]?.index,
      );
      const menuList = (
        (item?.item_auth_value || {})[item.menu_key] || []
      )?.sort((a, b) => codeObj[a]?.index - codeObj[b]?.index);
      //最多显示几个内容
      const max = 1;
      return (
        <div className="moreSelectDiv">
          <div className="menuDiv">
            <div className="typeDiv">{item.menu_key}</div>
            {menuList?.slice(0, max)?.map((_) => (
              <span>{codeObj[_]?.name}</span>
            ))}
            {menuList?.length > max && (
              <Tooltip
                overlayClassName="moreSelectTooltip"
                placement="bottom"
                title={
                  <div className="moreSelectTooltipDiv">
                    {menuList?.slice(max)?.map((_) => (
                      <span>{codeObj[_]?.name}</span>
                    ))}
                  </div>
                }
                color="#fff"
              >
                <div className="countDiv">{menuList?.length - max}</div>
              </Tooltip>
            )}
          </div>
          <div className="funcDiv">
            <div className="typeDiv">{item.fun_key}</div>
            {funList?.slice(0, max)?.map((_) => (
              <span>{codeObj[_]?.name}</span>
            ))}
            {funList?.length > max && (
              <Tooltip
                overlayClassName="moreSelectTooltip"
                placement="bottom"
                title={
                  <div className="moreSelectTooltipDiv">
                    {funList?.slice(max)?.map((_) => (
                      <span>{codeObj[_]?.name}</span>
                    ))}
                  </div>
                }
                color="#fff"
              >
                <div className="countDiv">{funList?.length - max}</div>
              </Tooltip>
            )}
          </div>
        </div>
      );
    }
    //许可项类型 显示中文
    if (column.key === "subs_plan_item_type_code") {
      return (
        <div>
          <Paragraph
            style={{ marginBottom: "0px" }}
            ellipsis={{
              rows: 2,
              tooltip: {
                title: item?.dic_item_name || "-",
              },
            }}
          >
            <div
              style={{
                textAlign: "left",
                whiteSpace: "pre-wrap",
              }}
            >
              {item?.dic_item_name || "-"}
            </div>
          </Paragraph>
        </div>
      );
    }
    return (
      <div>
        <Paragraph
          style={{ marginBottom: "0px" }}
          ellipsis={{
            rows: 2,
            tooltip: {
              title: item[column.key] || "-",
            },
          }}
        >
          <div
            style={{
              textAlign: "left",
              whiteSpace: "pre-wrap",
            }}
          >
            {item[column.key] ?? "-"}
          </div>
        </Paragraph>
      </div>
    );
  };

  const initHistoryItem = (item, column, index) => {
    return (
      <div>
        <Paragraph
          style={{ marginBottom: "0px" }}
          ellipsis={{
            rows: 2,
            tooltip: {
              title: column.get(item) || "-",
            },
          }}
        >
          <div
            style={{
              textAlign: "left",
              whiteSpace: "pre-wrap",
            }}
          >
            {column.get(item) ?? "-"}
          </div>
        </Paragraph>
      </div>
    );
  };

  const createFunc = () => {
    const params = {};
    //产品名称
    if (!userId) {
      message.info("请选择订阅用户");
      return;
    }

    if (personalEnterprise) {
      params.user_id = userId;
    } else {
      params.main_user_id = userId;
      if (companyId) {
        params.co_id = companyId;
      }
    }

    //订阅方案
    if (!planId) {
      message.info("请选择订阅方案");
      return;
    }
    const item = planList?.find((_) => _?.ver_info.subs_plan_id === planId);
    params.subs_plan_id = item?.ver_info.subs_plan_id || planId;
    if (item?.subs_plan_info?.prd_id) {
      params.prd_id = item?.subs_plan_info.prd_id;
    }

    // Duration params
    params.subs_dur_type = subsDurType;
    params.subs_dur_num = subsDurNum;
    if (type === "新增") {
      params.is_auto_renew = isAutoRenew ? 1 : 0;
    }
    if (!personalEnterprise) {
      params.sub_acct_num = subAcctNum;
    }

    let apiMethod;
    if (personalEnterprise) {
      if (type === "新增") {
        apiMethod = apis.addTocPersonalSubscription;
      } else if (type === "续订") {
        apiMethod = apis.renewTocPersonalSubscription;
      } else {
        // Default or Upgrade (if supported later)
        apiMethod = apis.addTocPersonalSubscription;
      }
    } else {
      if (type === "新增") {
        apiMethod = apis.addTocEnterpriseSubscription;
      } else if (type === "续订") {
        apiMethod = apis.renewTocEnterpriseSubscription;
      } else {
        // Default or Upgrade
        apiMethod = apis.addTocEnterpriseSubscription;
      }
    }

    // Fix parameter names for TOC API
    if (type === "续订") {
      params.toc_subs_id = selectItem.toc_subs_id;
      delete params.subs_plan_id;
      delete params.prd_id;
      delete params.user_id;
      delete params.main_user_id;
      delete params.co_id;

      // Personal renew: toc_subs_id, subs_dur_type, subs_dur_num
      // Enterprise renew: toc_subs_id, subs_dur_type, subs_dur_num, sub_acct_num
    }

    setSubmitLoading(true);
    apiMethod(params)
      .then((res) => {
        console.log(res);
        setSubmitLoading(false);
        if (res.code === 200) {
          setEditShow(false);
          getDataFunc();
        } else {
          message.error(res.message);
        }
      })
      .catch(() => setSubmitLoading(false));
  };

  // Removed old handlers

  return (
    <div className="editHtmlContent2">
      <div className="itemTitle">
        <span></span>
        {type === "新增" ? "订阅" : type === "查看" ? "查看订阅" : type}
      </div>
      <div className="itemTitle2">
        <span>
          01<i></i>
        </span>
        订阅信息
      </div>
      {/* 订阅信息 */}
      <div className="subscriptionItemsContent">
        <div
          className="subscriptionItem"
          style={{ width: type === "升级" ? "100%" : "50%" }}
        >
          <i>*</i>
          <span className="itemLabel">订阅用户</span>
          {type === "新增" ? (
            <Select
              style={{ width: "500px" }}
              loading={searchLoading}
              showSearch
              value={userId}
              defaultActiveFirstOption={false}
              filterOption={false}
              onSearch={(val) => debounceUserFetcher(val)}
              onChange={(val, opt) => {
                setUserId(val);
                setCompanyId(null);
                setCompanys([]);
                if (val && productPrdId) {
                  fetchUserCompanies(val, productPrdId);
                }
              }}
              notFoundContent={null}
              allowClear
              onClear={() => {
                setUserId(null);
                setUserList([]);
                setCompanyId(null);
                setCompanys([]);
              }}
              options={(userList || []).map((d) => ({
                value: d.co_user_id || d.user_id,
                label: (
                  <div>
                    <span style={{ fontSize: "14px", color: "#333" }}>
                      {d.mobile_no || d.phone}
                    </span>
                    <span
                      style={{
                        fontSize: "12px",
                        color: "#787878",
                        marginLeft: "4px",
                      }}
                    >
                      {d.show_name || d.nick_name || d.user_name}
                    </span>
                  </div>
                ),
              }))}
              popupMatchSelectWidth={false}
              placeholder="请输入手机号搜索用户"
            />
          ) : (
            <div>
              <span style={{ fontSize: "14px", color: "#333" }}>
                {detailInfo?.user_phone || detailInfo?.mobile_no}
              </span>
              <span
                style={{
                  fontSize: "12px",
                  color: "#787878",
                  marginLeft: "4px",
                }}
              >
                {detailInfo?.show_name ||
                  detailInfo?.user_nickname ||
                  detailInfo?.user_name}
              </span>
            </div>
          )}
        </div>

        <div className="subscriptionItem">
          <i>*</i>
          <span className="itemLabel">产品名称</span>
          {type === "新增" ? (
            <Select
              style={{
                width: "500px",
              }}
              showSearch
              filterOption={(input, option) =>
                (option?.label ?? "")
                  .toLowerCase()
                  .includes(input.toLowerCase())
              }
              onChange={(value, opt) => {
                setProductId(value);
                const selectedPrdId = opt?.prd_id;
                setProductPrdId(selectedPrdId);
                setPlanId(null);
                setLicenseItemsList([]);
                setCompanyId(null);
                setCompanys([]);
                if (userId && selectedPrdId) {
                  fetchUserCompanies(userId, selectedPrdId);
                }
                setTimeout(() => {
                  getPlanListFunc();
                }, 50);
              }}
              value={productId}
              options={productList?.map((_) => ({
                value: _.prd_name,
                prd_id: _.prd_id,
                label: _.prd_name,
              }))}
              placeholder="请选择产品名称"
            />
          ) : (
            <div>
              {typeof detailInfo?.product_name === "string"
                ? detailInfo?.product_name
                : detailInfo?.product_name?.prd_name}
            </div>
          )}
        </div>

        {!personalEnterprise && (
          <div className="subscriptionItem">
            <i>{!personalEnterprise ? "*" : ""}</i>
            <span className="itemLabel">所属企业</span>
            {type === "新增" ? (
              <Select
                style={{ width: "500px" }}
                value={companyId}
                onChange={(val, opt) => {
                  setCompanyId(val);
                  setCompanyName(opt?.label);
                }}
                options={(companys || []).map((d) => ({
                  value: d.toc_co_id,
                  label: d.toc_co_name,
                }))}
                placeholder={
                  companys.length > 0 ? "请选择所属企业" : "无关联企业"
                }
                disabled={true}
                allowClear
              />
            ) : (
              <div>{detailInfo?.co_name || detailInfo?.toc_co_name || "-"}</div>
            )}
          </div>
        )}

        <div className="subscriptionItem">
          <i>*</i>
          <span className="itemLabel">版本类型</span>
          {type === "新增" ? (
            <Select
              style={{
                width: "500px",
              }}
              showSearch
              filterOption={(input, option) =>
                (option?.label ?? "")
                  .toLowerCase()
                  .includes(input.toLowerCase())
              }
              onChange={(value) => {
                setVersionType(value);
                setPlanId(null);
                setLicenseItemsList([]);
                setTimeout(() => {
                  getPlanListFunc();
                }, 50);
              }}
              value={versionType}
              options={versionTypeList}
              placeholder="请选择版本类型"
            />
          ) : (
            <div>
              {versionTypeList.find(
                (v) =>
                  v.value ===
                  (detailInfo?.version_type_code ||
                    detailInfo?.subs_plan?.version_type_code),
              )?.label ||
                detailInfo?.version_type_name ||
                detailInfo?.subs_plan?.version_type_name ||
                detailInfo?.version_type_code}
            </div>
          )}
        </div>
        <div className="subscriptionItem">
          <i>*</i>
          <span className="itemLabel">订阅方案名称</span>
          {type === "新增" ? (
            <Select
              style={{
                width: "500px",
              }}
              notFoundContent={
                getProductId() && getVersionType() ? undefined : (
                  <div
                    style={{
                      width: "100%",
                      padding: "10px",
                      textAlign: "center",
                      color: "rgba(0, 0, 0, 0.45)",
                    }}
                  >
                    请先选择产品名称和版本类型
                  </div>
                )
              }
              onChange={(value) => {
                setPlanId(value);
                setCheckStatus(false);
                const item = planList?.find(
                  (_) => _?.ver_info.subs_plan_id === value,
                );
                // setVersionType(item.subs_plan_info.version_type_code);
                getLicenseItemsList(
                  item.subs_plan_info?.prd_co_id,
                  item.subs_plan_item,
                );
              }}
              value={planId}
              options={planList?.map((_) => ({
                value: _?.ver_info.subs_plan_id,
                label: (
                  <div className="verLabelBox">
                    {_?.ver_info.subs_plan_name}
                    <span className="verNo">({_?.ver_info?.ver_no})</span>
                  </div>
                ),
                key: _?.ver_info.subs_plan_id,
              }))}
              placeholder="请选择订阅方案"
            />
          ) : (
            <div style={{ width: "calc(100% - 60px)" }}>
              <Paragraph
                style={{ marginBottom: "0px" }}
                ellipsis={{
                  rows: 2,
                  tooltip: {
                    title:
                      (detailInfo?.subs_plan_name ||
                        detailInfo?.subs_plan_ver?.subs_plan_name) +
                      `(${detailInfo?.ver_no || detailInfo?.subs_plan_ver?.ver_no})`,
                  },
                }}
              >
                <div
                  style={{
                    textAlign: "left",
                    whiteSpace: "pre-wrap",
                  }}
                >
                  <div className="verLabelBox">
                    {detailInfo?.subs_plan_name ||
                      detailInfo?.subs_plan_ver?.subs_plan_name}
                    <span className="verNo">
                      ({detailInfo?.ver_no || detailInfo?.subs_plan_ver?.ver_no}
                      )
                    </span>
                  </div>
                </div>
              </Paragraph>
            </div>
          )}
        </div>

        {/* Added Duration Field */}
        {(type === "新增" || type === "续订") && (
          <div className="subscriptionItem">
            <i>*</i>
            <span className="itemLabel">订阅时长</span>
            <Input.Group compact style={{ width: "500px", display: "flex" }}>
              <Select
                style={{ width: "120px" }}
                value={subsDurType}
                onChange={setSubsDurType}
                options={[
                  { label: "按月", value: "MONTH" },
                  { label: "按年", value: "YEAR" },
                ]}
              />
              <Input
                style={{ width: "calc(100% - 120px)" }}
                type="number"
                value={subsDurNum}
                onChange={(e) => setSubsDurNum(parseInt(e.target.value) || 0)}
                addonAfter={subsDurType === "MONTH" ? "个月" : "年"}
              />
            </Input.Group>
          </div>
        )}

        {/* Auto Renew Switch - Commented out as requested */}
        {/* {type === '新增' && (
            <div className="subscriptionItem">
                <i></i>
                <span className="itemLabel">自动续订</span>
                <Switch 
                    checked={isAutoRenew} 
                    onChange={setIsAutoRenew} 
                    checkedChildren="是" 
                    unCheckedChildren="否"
                />
            </div>
        )} */}

        {/* Sub Account Num for Enterprise */}
        {!personalEnterprise && (
          <div className="subscriptionItem">
            <i></i>
            <span className="itemLabel">子账号数量</span>
            {type === "新增" ? (
              <Input
                style={{
                  width: "500px",
                  textAlign: "center",
                  height: "32px",
                  padding: "0px",
                }}
                value={subAcctNum}
                onChange={(e) => {
                  const val = e.target.value.replace(/[^\d]/g, "");
                  setSubAcctNum(val ? parseInt(val) : 0);
                }}
                prefix={
                  <MinusOutlined
                    style={{
                      cursor: subAcctNum <= 0 ? "not-allowed" : "pointer",
                      fontSize: "14px",
                      color: subAcctNum <= 0 ? "#ccc" : "#666",
                      background: "#f5f5f5",
                      padding: "4px 8px",
                      borderRight: "1px solid #d9d9d9",
                      marginRight: "8px",
                      height: "100%",
                    }}
                    onClick={() =>
                      setSubAcctNum((prev) => Math.max(0, (prev || 0) - 1))
                    }
                  />
                }
                suffix={
                  <PlusOutlined
                    style={{
                      cursor: "pointer",
                      fontSize: "14px",
                      color: "#666",
                      background: "#f5f5f5",
                      padding: "4px 8px",
                      borderLeft: "1px solid #d9d9d9",
                      marginLeft: "8px",
                      height: "100%",
                    }}
                    onClick={() => setSubAcctNum((prev) => (prev || 0) + 1)}
                  />
                }
                placeholder="请输入子账号数量"
              />
            ) : (
              <div>{subAcctNum}</div>
            )}
          </div>
        )}
      </div>

      {/* 许可项信息 */}
      <Spin spinning={detailLoading}>
        <div className="itemTitle2">
          <span>
            02
            <i></i>
          </span>
          许可项信息
        </div>
        {/* 订阅许可项 */}
        <div className="subscriptionLicenseItemsContent">
          <div className="subscriptionLicenseItemsHeader">
            {licenseColumns?.map((item) => (
              <div
                className="headerItem"
                style={{ width: item.width }}
                key={item.name}
              >
                <i>{item?.require ? "*" : ""}</i>
                {item.name}
              </div>
            ))}
          </div>
          {licenseItemsList?.length > 0 || type === "查看" ? (
            info?.map((item, index) => (
              <div className="subscriptionLicenseItemLine" key={index}>
                {licenseColumns?.map((column) => (
                  <div
                    className="itemBox"
                    style={{ width: column.width }}
                    key={column.key}
                  >
                    {initItem(item, column, index)}
                  </div>
                ))}
              </div>
            ))
          ) : (
            <div className="subscriptionLicenseEmptyItem">
              选择订阅方案后配置许可项
            </div>
          )}
        </div>
        {/* ---- */}
        {type === "查看" &&
          (historyEnterprise?.length > 0 || detailLoading) && (
            <>
              <div className="itemTitle2" style={{ marginTop: "24px" }}>
                <span>
                  03<i></i>
                </span>
                订阅历史
              </div>
              <div className="subscriptionLicenseItemsContent">
                <div className="subscriptionLicenseItemsHeader">
                  {tocHistoryColumns?.map((item) => (
                    <div
                      className="headerItem"
                      style={{ width: item.width, flex: item.flex }}
                    >
                      <i>{item?.require ? "*" : ""}</i>
                      {item.name}
                    </div>
                  ))}
                </div>
                {historyEnterprise?.map((item, index) => (
                  <div className="subscriptionLicenseItemLine" key={index}>
                    {tocHistoryColumns?.map((column) => (
                      <div
                        className="itemBox"
                        style={{ width: column.width, flex: column.flex }}
                        key={column.key}
                      >
                        {column.render
                          ? column.render(item)
                          : item[column.key] || "-"}
                      </div>
                    ))}
                  </div>
                ))}
              </div>
            </>
          )}
      </Spin>
      {/* ---- */}
      <div className="subscriptionLicenseBtnBox">
        <Button
          onClick={() => {
            setEditShow(false);
          }}
        >
          取消
        </Button>
        {type !== "查看" && (
          <Button
            style={{ marginLeft: "24px" }}
            type="primary"
            loading={submitLoading}
            onClick={createFunc}
          >
            确定
          </Button>
        )}
      </div>
    </div>
  );
};

export default EditHtml;
